import { useNoteTemplates } from "@/lib/replicache"

export const useCurrentTemplate = () => {
	const templates = useNoteTemplates()
	const [currentTemplate] = templates
	return currentTemplate
}
